<template>
  <div>
    <b-table
      :items="items"
      :fields="fields"
      :tbody-tr-class="rowClass"
      class="mt-3 package-table"
      responsive
      outlined
    >
      <template #head()="scope">
        <div>{{ $t(scope.label) }}</div>
      </template>
      <template #head(selected)>
        <div>
          <input
            type="checkbox"
            id="checkbox"
            v-model="selectAllCheckBox"
            @change="onChangeSelectAllCheckBox(selectAllCheckBox)"
            :disabled="disableSelectAllCheckBox"
          />
        </div>
      </template>
      <template #cell(selected)="row">
        <input
          type="checkbox"
          id="checkbox"
          v-model="row.item.isSelect"
          @change="onSelectAssetActivityPlan(row.item, row.item.isSelect)"
          :disabled="row.item.isDisableCheckbox"
        />
      </template>
      <template #cell(assetStatus)="row">
        <div v-if="row.item.isDeleted">
          {{ $t("property.asset.statusList.deleted") }}
        </div>
        <div v-else-if="row.item.activityPlanStatus">
          {{ $t(getActivityPlanStatusName(row.item.activityPlanStatus)) }}
        </div>
        <div v-else>
          {{ row.item.assetStatus }}
        </div>
      </template>
      <template #cell(activityPlanPrice)="row">
        <div>
          {{ currencyFormat(row.item.activityPlanPrice) }}
        </div>
      </template>
      <template #cell(assetName)="row">
        {{ row.item.assetName }}
        <div>
          <span
            class="detail-activity hover-action"
            @click="onShowActivityPlanDetail(row.item)"
          >
            <small>{{ $t("common.detail") }}</small>
          </span>
        </div>
      </template>
    </b-table>

    <div class="box-footer clearfix" style="display:contents;">
      <hr />
      <paginator
        :totalItem="paginateData.totalItem"
        :currentPage="paginateData.currentPage"
        :pageSize="paginateData.pageSize"
        :totalPage="paginateData.totalPage"
        @onpaginate="onPagination"
      />
    </div>
    <!--  -->
    <select-multiplate-asset-modal
      ref="selectMultiplateAssetActivityTrackingModal"
      :modalTitle="modalTitle"
      :filterAssetActivityTracking="true"
      :isShowMaintenanceType="true"
      :isShowTitle="true"
      :isShowPrice="true"
      :isShowDescription="true"
      :isAssetTable="isAssetTable"
      @emitAssetSelect="emitAssetSelectFunction"
    />
    <!--  -->
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
    <!--  -->
    <maintenance-modal
      ref="maintenanceModal"
      @callbackMaintenanceList="callbackActivityPlan"
    />
    <!--  -->
    <asset-in-activity-detail-modal
      ref="assetInActivityDetailModal"
      :modalTitle="assetInActivityPlanDetailModalTitle"
      isShowMaintenanceType
      isShowTitle
      isShowDescription
      isShowPrice
      :isShowSaveBtn="isShowSaveBtn"
      :isShowHistory="isShowHistory"
      @emitAssetSelect="emitAssetSelectFunction"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import Paginator from "@/components/CustomPaginator.vue";
import SelectMultiplateAssetModal from "./SelectMultiplateAssetModal";
import LTEModal from "@/components/LTEModal.vue";
import MaintenanceModal from "./MaintenanceModal";
import AssetInActivityDetailModal from "./AssetInActivityDetailModal";
import Enum from "../../../enum/enum";

export default {
  components: {
    "lte-modal": LTEModal,
    SelectMultiplateAssetModal,
    MaintenanceModal,
    AssetInActivityDetailModal,
    paginator: Paginator
  },
  props: {
    historyTabSelect: {
      type: Number,
      default: () => {
        return null
      }
    },
    maintenanceTabSelect: {
      type: Number,
      default: () => {
        return null
      }
    }
  },
  data: () => ({
    isLoading: false,
    items: [],
    fields: [],
    activityPlanFields: [
      { key: "selected" },
      {
        key: "nonumber",
        label: "common.nonumber",
        sortable: false,
        class: "text-center"
      },
      {
        key: "assetCode",
        label: "propertyMaintenance.assetCode",
        sortable: false
      },
      {
        key: "assetName",
        label: "property.asset.name",
        sortable: false
      },
      // {
      //   key: "assetLocation",
      //   label: "property.asset.location",
      //   sortable: false
      // },
      {
        key: "seriCode",
        label: "property.asset.seriCode",
        sortable: false
      },
      {
        key: "assetModel",
        label: "property.asset.model",
        sortable: false
      },
      {
        key: "activityPlanTitle",
        label: "propertyMaintenance.maintenanceTitle",
        sortable: false
      },
      {
        key: "activityPlanPrice",
        label: "propertyMaintenance.price",
        sortable: false
      },
      {
        key: "typeOfMaintenance",
        label: "propertyMaintenance.typeOfMaintenance",
        sortable: false
      },
      {
        key: "assetStatus",
        label: "property.asset.status",
        sortable: false
      }
    ],
    activityPlanHistoryFields: [
      {
        key: "nonumber",
        label: "common.nonumber",
        sortable: false,
        class: "text-center"
      },
      {
        key: "assetCode",
        label: "propertyMaintenance.assetCode",
        sortable: false
      },
      {
        key: "assetName",
        label: "property.asset.name",
        sortable: false
      },
      {
        key: "assetLocation",
        label: "property.asset.location",
        sortable: false
      },
      {
        key: "seriCode",
        label: "property.asset.seriCode",
        sortable: false
      },
      {
        key: "assetModel",
        label: "property.asset.model",
        sortable: false
      },
      {
        key: "activityPlanTitle",
        label: "propertyMaintenance.maintenanceTitle",
        sortable: false
      },
      {
        key: "activityPlanPrice",
        label: "propertyMaintenance.price",
        sortable: false
      },
      {
        key: "typeOfMaintenance",
        label: "propertyMaintenance.typeOfMaintenance",
        sortable: false
      },
      {
        key: "assetStatus",
        label: "property.asset.status",
        sortable: false
      },
      {
        key: "dateUpdated",
        label: "common.dateUpdated",
        sortable: false
      }
    ],
    assetIds: [],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    searchData: {
      searchText: null,
      fromDate: null,
      toDate: null,
      maintenanceTypeValue: null,
      isGetHistory: false
    },
    isAssetTable: false,
    maintenanceTypeValue: 1,
    modalTitle: "",
    titleData: null,
    priceData: null,
    description: null,
    //
    selectAllCheckBox: false,
    disableSelectAllCheckBox: false,
    constDisableSelectAllCheckBox: false,
    maintenanceTypeCheckBoxSelect: null,
    activityPlanSelectIds: [],
    isModalVisible: false,
    objModal: [
      {
        title: "propertyMaintenance.removeAssetPlanList.title",
        body: "",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    assetInActivityPlanDetailModalTitle: "",
    activityPlanId: null,
    isShowSaveBtn: false,
    isShowHistory: false
  }),
  watch: {
    GET_ACTIVITY_PLAN_LIST_DATA: function() {
      let paginate = this.GET_ACTIVITY_PLAN_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.items = [];
      this.selectAllCheckBox = false;
      let data = this.GET_ACTIVITY_PLAN_LIST_DATA.results;
      let checkMaintenanceType = null;
      if (data.length === 0 || this.searchData.isGetHistory) {
        this.constDisableSelectAllCheckBox = true;
      } else {
        this.constDisableSelectAllCheckBox = false;
        this.maintenanceTypeCheckBoxSelect = null;
      }

      data.forEach((e, i) => {
        if (i === 0) {
          checkMaintenanceType = e.maintenance_type_data.id;
        }
        if (e.maintenance_type_data.id !== checkMaintenanceType) {
          this.constDisableSelectAllCheckBox = true;
        }
        let assetId = e.asset_id;
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;
        let item = {
          id: e.id,
          assetId: assetId,
          nonumber: nonumber,
          assetCode: e.code,
          assetName: e.name,
          assetLocation: e.location,
          seriCode: e.seri_code,
          assetModel: e.asset_model,
          nextMaintainanceDate: utils.formatSqlDate(e.next_maintainance_date, null, "DD/MM/YYYY"),
          assetStatus: e.status,
          activityPlanTitle: e.title,
          typeOfMaintenance: e.maintenance_type_data.default,
          maintenanceTypeId: e.maintenance_type_data.id,
          activityPlanPrice: e.price,
          isSelect: false,
          isDisableCheckbox: this.searchData.isGetHistory ? true : false,
          isDeleted: e.is_deleted,
          description: e.description,
          dateUpdated: utils.formatSqlDate(e.date_updated, null, "DD/MM/YYYY"),
          activityPlanStatus: e.activity_plan_status
        };
        this.items.push(item);
      });
      this.disableSelectAllCheckBox = this.constDisableSelectAllCheckBox;
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACTIVITY_PLAN_LIST_DATA"
    ])
  },
  methods: {
    rowClass: function(item, type) {
      if (!item || type !== "row") return;
      if (item.isDeleted) {
        return "asset-is-deleted";
      }
      if (!this.searchData.isGetHistory && item.isDisableCheckbox) {
        return "disable-activity-plan";
      }
      return "";
    },
    currencyFormat: function(value) {
      if (!utils.isEmptyString(value)) {
        return utils.formatNumber(value);
      }
      return null;
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    emitAssetSelectFunction: function(data) {
      let objKey = Object.keys(data);
      if (objKey.includes("maintenanceType")) {
        this.maintenanceTypeValue = data.maintenanceType;
      }
      if (objKey.includes("title")) {
        this.titleData = data.title;
      }
      if (objKey.includes("description")) {
        this.description = data.description;
      }
      if (objKey.includes("price")) {
        this.priceData = data.price;
      }
      if (objKey.includes("assetList")) {
        let assetData = data.assetList;
        if (assetData.length === 0) {
          this.showError("propertyMaintenance.errorSelectAsset");
        } else {
          this.assetIds = [];
          assetData.forEach(e => {
            this.assetIds.push(e.id);
          });
          this.onSaveAssetActivityPlan();
        }
      }
      if (objKey.includes("activityPlanId")) {
        this.activityPlanId = data.activityPlanId;
        this.onUpdateAssetActivityPlan();
      }
    },
    onSaveAssetActivityPlan: function() {
      let data = {
        assetIds: this.assetIds,
        maintenanceType: this.maintenanceTypeValue,
        title: this.titleData,
        price: this.priceData,
        description: this.description
      };
      this.POST_ASSET_LIST_ACTIVITY_PLAN(data)
        .then(
          function() {
            this.isLoading = false;
            this.onSearchActivityTracking(this.paginateData.currentPage);
            this.$refs.selectMultiplateAssetActivityTrackingModal.onCloseModal();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
            this.isLoading = false;
          }.bind(this)
        );
    },
    onUpdateAssetActivityPlan: function() {
      let data = {
        id: this.activityPlanId,
        maintenanceType: this.maintenanceTypeValue,
        title: this.titleData,
        price: this.priceData,
        description: this.description
      };
      this.UPDATE_ASSET_ACTIVITY_PLAN(data)
        .then(
          function() {
            this.isLoading = false;
            this.onSearchActivityTracking(this.paginateData.currentPage);
            this.$refs.assetInActivityDetailModal.onCloseModal();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
            this.isLoading = false;
          }.bind(this)
        );
    },
    addAssetActivityTracking: function(maintenanceTypeValue) {
      if (maintenanceTypeValue === Enum.MaintenanceTypeEnum.INCIDENT) {
        this.maintenanceTypeValue = maintenanceTypeValue;
        this.modalTitle = "propertyMaintenance.addIncidentReport";
      } else {
        this.maintenanceTypeValue = Enum.MaintenanceTypeEnum.MAINTENANCE;
        this.modalTitle = "propertyMaintenance.addNewDevicePlan";
      }
      this.isAssetTable = true;
      this.$refs.selectMultiplateAssetActivityTrackingModal.onSelectAsset(
        this.maintenanceTypeValue,
        null
      );
    },
    getActivityTrackingList: function(page) {
      let filter = {
        params: {
          page: page,
          searchText: this.searchData.searchText,
          nextImplementationDateFromDate: utils.formatSqlUtcDate(this.searchData.fromDate, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss"),
          nextImplementationDateToDate: utils.formatSqlUtcDate(this.searchData.toDate, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss"),
          // statusList: [Enum.AssetActivityPlanEnum.CREATE],
          isGetHistory: this.searchData.isGetHistory,
          maintenanceTypeValue: this.searchData.maintenanceTypeValue
        }
      };
      if (this.searchData.isGetHistory) {
        filter.params["excludeStatusList"] = [
          Enum.AssetActivityPlanEnum.CREATE
        ];
      } else {
        filter.params["statusList"] = [Enum.AssetActivityPlanEnum.CREATE];
      }
      this.GET_ACTIVITY_PLAN_LIST(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onRefreshData: function(data) {
      if (data.isGetHistory) {
        this.fields = this.activityPlanHistoryFields
      } else {
        this.fields = this.activityPlanFields
      }
      this.onSearchActivityTracking(data);
    },
    onPagination: function(data) {
      this.getActivityTrackingList(data);
    },
    onSearchActivityTracking: function(data) {
      this.searchData.searchText = data.searchText;
      this.searchData.fromDate = data.from_date;
      this.searchData.toDate = data.to_date;
      this.searchData.isGetHistory = data.isGetHistory;
      this.searchData.maintenanceTypeValue = data.maintenanceTypeValue;
      this.getActivityTrackingList(this.paginateData.currentPage);
    },
    //
    onChangeSelectAllCheckBox: function(checkboxValue) {
      this.activityPlanSelectIds = [];
      if (checkboxValue) {
        this.items.filter(x => {
          if (
            checkboxValue &&
            this.activityPlanSelectIds.includes(x.id) === false &&
            this.maintenanceTypeCheckBoxSelect === x.maintenanceTypeId
          ) {
            this.activityPlanSelectIds.push(x.id);
            return (x.isSelect = checkboxValue);
          } else if (this.maintenanceTypeCheckBoxSelect === null) {
            this.activityPlanSelectIds.push(x.id);
            this.maintenanceTypeCheckBoxSelect = x.maintenanceTypeId;
            return (x.isSelect = checkboxValue);
          }
          // if (this.maintenanceTypeCheckBoxSelect === x.maintenanceTypeId) {
          //   return (x.isSelect = checkboxValue);
          // }
        });
      } else {
        this.maintenanceTypeCheckBoxSelect = null;
        this.items.filter(x => {
          return (x.isSelect = checkboxValue), (x.isDisableCheckbox = false);
        });
        this.disableSelectAllCheckBox = this.constDisableSelectAllCheckBox;
      }
    },
    onSelectAssetActivityPlan: function(item, checkboxValue) {
      if (
        checkboxValue &&
        this.activityPlanSelectIds.includes(item.id) === false
      ) {
        this.items.filter(x => {
          this.maintenanceTypeCheckBoxSelect = item.maintenanceTypeId;
          if (x.maintenanceTypeId !== item.maintenanceTypeId) {
            this.disableSelectAllCheckBox = false;
            return (x.isDisableCheckbox = true);
          }
        });
        this.activityPlanSelectIds.push(item.id);
      } else {
        let index = this.activityPlanSelectIds.findIndex(x => x === item.id);
        if (index !== -1) {
          this.activityPlanSelectIds.splice(index, 1);
        }
      }
      if (this.activityPlanSelectIds.length === 0) {
        this.maintenanceTypeCheckBoxSelect = null;
        this.items.filter(x => {
          this.disableSelectAllCheckBox = this.constDisableSelectAllCheckBox;
          return (x.isDisableCheckbox = false);
        });
      }
      let excludeActivityPlanSelect = this.items.filter(
        x => x.maintenanceTypeId !== item.maintenanceTypeId
      );
      if (
        this.activityPlanSelectIds.length ===
          this.items.length - excludeActivityPlanSelect.length &&
        this.items.length > 0 &&
        excludeActivityPlanSelect.length > 0
      ) {
        this.selectAllCheckBox = true;
      } else {
        this.selectAllCheckBox = false;
      }
    },
    closeModal: function() {
      this.isModalVisible = false;
    },
    // remove activity plan list
    onRemoveActivityPlanList: function() {
      if (this.activityPlanSelectIds.length === 0) {
        this.showError("propertyMaintenance.errorSelectActivityPlan");
      } else {
        this.objModal[0].body = this.$t(
          "propertyMaintenance.removeAssetPlanList.body",
          { 0: this.activityPlanSelectIds.length }
        );
        this.isModalVisible = true;
      }
    },
    onConfirm: function() {
      let data = {
        ids: this.activityPlanSelectIds
      };
      this.REMOVE_ASSET_LIST_ACTIVITY_PLAN(data)
        .then(
          function() {
            this.isLoading = false;
            // set data null
            this.activityPlanSelectIds = [];
            this.isModalVisible = false;
            this.getActivityTrackingList(this.paginateData.currentPage);
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onAddMaintenanceProcessing: function() {
      if (this.activityPlanSelectIds.length === 0) {
        this.showError("propertyMaintenance.errorSelectActivityPlan");
      } else {
        this.$refs.maintenanceModal.addNew(
          Enum.MaintenanceStatusEnum.MAINTENANCE_IN_PROCESSING,
          null,
          null,
          this.maintenanceTypeCheckBoxSelect,
          this.activityPlanSelectIds
        );
      }
    },
    callbackActivityPlan: function() {
      this.activityPlanSelectIds = []
      this.getActivityTrackingList(this.paginateData.currentPage);
    },
    onShowActivityPlanDetail: function(data) {
      if (this.historyTabSelect && this.maintenanceTabSelect !== null) {
        this.isShowSaveBtn = true
        this.isShowHistory = false
        this.assetInActivityPlanDetailModalTitle =
          "propertyMaintenance.activityPlanDetail";
      } else {
        this.isShowSaveBtn = false
        this.isShowHistory = true
        this.assetInActivityPlanDetailModalTitle =
          "propertyMaintenance.maintenanceHistory.historyActivityPlanDetail";
      }
      this.$refs.assetInActivityDetailModal.onGetData(
        data.assetId,
        data.id,
        data.activityPlanTitle,
        data.maintenanceTypeId,
        data.activityPlanPrice,
        data.description
      );
    },
    getActivityPlanStatusName: function(value) {
      let results = ''
      switch (value) {
        case Enum.AssetActivityPlanEnum.IN_PROCESSING:
          results =  'propertyMaintenance.statusList.processing'
          break;
        case Enum.AssetActivityPlanEnum.COMPLETE:
          results = "propertyMaintenance.assetInProcessingMaintenanceStatus.processed"
          break;
        case Enum.AssetActivityPlanEnum.CANCEL:
          results = "propertyMaintenance.assetInProcessingMaintenanceStatus.noProcessing"
          break;
        case Enum.AssetActivityPlanEnum.REMOVE:
          results = "propertyMaintenance.assetInProcessingMaintenanceStatus.removed"
          break;
        default:
          break;
      }
      return results
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "POST_ASSET_LIST_ACTIVITY_PLAN",
      "UPDATE_ASSET_ACTIVITY_PLAN",
      "REMOVE_ASSET_LIST_ACTIVITY_PLAN",
      "GET_ACTIVITY_PLAN_LIST"
    ])
  }
};
</script>
<style lang="scss" scoped>
.table-responsive /deep/ .b-table .disable-activity-plan {
  background: #dddddd;
  color: #7c7c7c;
}
.table-responsive /deep/ .b-table .asset-is-deleted {
  background: #f5c6cb;
}
.detail-activity {
  color: #006ad4;
}
.hover-action {
  cursor: pointer;
}
.hover-action:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/Property/ActivityPlanList.vue